export const getUserMeasureUnit = (data, measureName) => {
    return data[`${measureName}Unit`];
};
